﻿import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  IconButton,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import {
  DELETE_USER_EMAILS,
  DELETE_USER_PHONES,
  FETCH_PROVINCES,
  GETUSERINFO,
  SAVE_USER_ADDRESS,
  SAVE_USER_PHONES,
  SAVE_USERE_MAILS,
  SEND_SMS_TO_USER_PHONE,
  SEND_USER_VERIFICATION_EMAIL
} from "../../constant/Apipath";
import { Getrequestcall } from "../../request/Getrequest";
import { BIBlue } from "../../assets/helpers";
import { RemoveCircle } from "@mui/icons-material";
import SearchMap from "../sites/SearchMap";
import { getAddress } from "../../request/Fetchcurrentaddress";
import moment from "moment/moment";
import Loader from "../../common/Loader";
import PropTypes from "prop-types";
import { IMaskInput } from "react-imask";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import { English } from "../../constant/EnglishFallback";
import { toast } from "react-toastify";

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(#00) 000-0000"
      definitions={{
        "#": /[1-9]/
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default function Editabout({
  showAbout,
  handleClose,
  getInformationData,
  setVerifyEmailModalOpen,
  setVerifyPhoneModalOpen,
  handledata,
  setAboutDataLoading,
  setEditedTab
}) {
  const [addressObj, setAddressObj] = useState({
    id: 0,
    address1: "",
    address2: "",
    city: "",
    province: "",
    country: "",
    postalCode: ""
  });

  const [searchTerm, setSearchTerm] = useState("");

  const [emails, setEmails] = useState([]);
  const [phones, setPhones] = useState([]);
  const countries = ["Canada", "United Kingdom", "United States"];
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const userId = loginData?.userInformation?.UserId;
  const [searchTextFlag, setSearchTextFlag] = useState(false);
  const [emailsToDelete, setEmailsToDelete] = useState([]);
  const [phonesToDelete, setPhonesToDelete] = useState([]);
  const [provinceList, setProvinceList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailModified, setIsEmailModified] = useState(false);
  const [isPhoneModified, setIsPhoneModified] = useState(false);
  const [isAddressModified, setIsAddressModified] = useState(false);
  const [changeCountry, setChangeCountry] = useState(false);
  const [phoneCopy, setPhoneCopy] = useState([]);

  const {
    BUTTON_DELETE = English?.Profile?.BUTTON_DELETE,
    TEXT_ENTER_VALID_EMAIL = English?.Profile?.TEXT_ENTER_VALID_EMAIL,
    TEXT_VALID_COUNTRY_CODE = English?.Profile?.TEXT_VALID_COUNTRY_CODE,
    TEXT_VALID_PHONE_CODE = English?.Profile?.TEXT_VALID_PHONE_CODE,
    TEXT_EDIT_ABOUT = English?.Profile?.TEXT_EDIT_ABOUT,
    TEXT_ABOUT_INSTRUCTION = English?.Profile?.TEXT_ABOUT_INSTRUCTION,
    TEXT_EMAILS = English?.Profile?.TEXT_EMAILS,
    TEXT_NEEDS_TO_BE_VERIFIED = English?.Profile?.TEXT_NEEDS_TO_BE_VERIFIED,
    BUTTON_VERIFY = English?.Profile?.BUTTON_VERIFY,
    TEXT_PRIMARY = English?.Profile?.TEXT_PRIMARY,
    TEXT_EMAIL_TYPE = English?.Profile?.TEXT_EMAIL_TYPE,
    TEXT_PERSONAL = English?.Profile?.TEXT_PERSONAL,
    TEXT_WORK = English?.Profile?.TEXT_WORK,
    TEXT_OTHER = English?.Profile?.TEXT_OTHER,
    TEXT_EMAIL = English?.Profile?.TEXT_EMAIL,
    BUTTON_ADD_EMAIL = English?.Profile?.BUTTON_ADD_EMAIL,
    TEXT_PHONE_NUMBERS = English?.Profile?.TEXT_PHONE_NUMBERS,
    TEXT_PHONE_TYPE = English?.Profile?.TEXT_PHONE_TYPE,
    TEXT_HOME = English?.Profile?.TEXT_HOME,
    TEXT_MOBILE = English?.Profile?.TEXT_MOBILE,
    TEXT_CODE = English?.Profile?.TEXT_CODE,
    TEXT_COUNTRY_CODE = English?.Profile?.TEXT_COUNTRY_CODE,
    TEXT_PHONE_NUMBER_PLACEHOLDER = English?.Profile?.TEXT_PHONE_NUMBER_PLACEHOLDER,
    BUTTON_ADD_PHONE = English?.Profile?.BUTTON_ADD_PHONE,
    TEXT_ADDRESS = English?.Profile?.TEXT_ADDRESS,
    TEXT_ADD_SUBHEADING = English?.Profile?.TEXT_ADD_SUBHEADING,
    TEXT_SELECT_COUNTRY = English?.Profile?.TEXT_SELECT_COUNTRY,
    TEXT_ADD_PLACEHOLDER = English?.Profile?.TEXT_ADD_PLACEHOLDER,
    TEXT_CITY_PLACEHOLDER = English?.Profile?.TEXT_CITY_PLACEHOLDER,
    TEXT_PROVIENCE = English?.Profile?.TEXT_PROVIENCE,
    TEXT_POSTAL_CODE = English?.Profile?.TEXT_POSTAL_CODE,
    TEXT_CLEAR_ADDRESS = English?.Profile?.TEXT_CLEAR_ADDRESS
  } = multiLanguageData?.Profile || {};

  useEffect(() => {
    if (addressObj?.country !== "") {
      const obj = {
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: false,
        NrOfRecPerPage: 50,
        SearchList: [
          {
            Country: addressObj?.country === "United States" ? "USA" : addressObj?.country
          }
        ]
      };
      Postrequestcall(FETCH_PROVINCES, obj, loginData?.accessToken)
        .then((res) => {
          setProvinceList(res?.data?.data);
        })
        .catch((err) => {
          console.log("UseEffect-> Error While Getting Provinces: ", err);
        });
    }
  }, [addressObj?.country]);

  const getInformationEdit = () => {
    try {
      setIsLoading(true);
      Promise.all([Getrequestcall(`${GETUSERINFO}/${userId}`, loginData?.accessToken)]).then(
        ([dashboardRes]) => {
          let getDashboardRes = dashboardRes?.data?.data;
          let getAddressRes = dashboardRes?.data?.data?.userAddresses;

          // Get emails
          setEmails([
            {
              id: getDashboardRes?.id,
              email: getDashboardRes?.userEmail,
              verified: getDashboardRes?.verified
            },
            ...getDashboardRes?.emails
            // ...emailRes?.data?.data
          ]);

          setPhones(getDashboardRes?.phones);
          setPhoneCopy(JSON.parse(JSON.stringify(getDashboardRes?.phones)));

          setAddressObj({
            id: getAddressRes?.id || 0,
            address1: getAddressRes?.address1 || "",
            address2: getAddressRes?.address2 || "",
            city: getAddressRes?.city || "",
            province: getAddressRes?.province || "",
            postalCode: getAddressRes?.postalCode || "",
            country: getAddressRes?.country || ""
          });
          setSearchTerm(getAddressRes?.address1);
          setIsLoading(false);
        }
      );
    } catch (error) {
      setIsLoading(false);
      throw error;
    }
  };

  useEffect(() => {
    getInformationEdit();
  }, []);

  const handleAddressChange = (e) => {
    let inputValue = e.target.value;
    if (e.target.name === "postalCode") {
      inputValue = inputValue.replace(/[^A-Za-z0-9]/g, "").slice(0, 6);
    } else {
      inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    }

    if (e.target.name == "country") {
      setAddressObj({
        id: 0,
        address1: "",
        address2: "",
        city: "",
        province: "",
        country: inputValue, // Only update 'country'
        postalCode: ""
      });
      setSearchTerm("");
    } else {
      setAddressObj({
        ...addressObj,
        [e.target.name]: inputValue // Update the corresponding field in addressObj
      });
    }
    setIsAddressModified(true);
    setChangeCountry(true);
  };

  function clearAddress() {
    setAddressObj({
      id: 0,
      address1: "",
      address2: "",
      city: "",
      province: "",
      country: "",
      postalCode: ""
    });
    setSearchTerm("");
    setIsAddressModified(true);
  }

  async function handleSaveButtonClick() {
    try {
      setAboutDataLoading(true);
      setEditedTab("");
      let showEmailError = false;
      let showPhoneError = false;
      let emailsToSave = [];
      let phonesToSave = [];

      if (isEmailModified) {
        let emailRegexp = new RegExp(
          /^[a-zA-Z][a-zA-Z0-9]*(\+[a-zA-Z0-9]+)?(\.[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,6}$/
        );
        const vaildEmail = emails.filter((e) => e.email != "" && emailRegexp.test(e.email));
        if (vaildEmail.length === emails.length) {
          showEmailError = false;
          emailsToSave = [...vaildEmail];
        } else {
          emailsToSave = [];
          alert(TEXT_ENTER_VALID_EMAIL);
          showEmailError = true;
          return;
        }
      }

      if (showEmailError) {
        return;
      }

      if (isPhoneModified) {
        const vaildPhoneNumber = phones.filter((p) => p.phoneNo !== "");
        if (vaildPhoneNumber.length === phones.length) {
          const vaildPhoneNumberCode = phones.filter((p) => p.countryCode !== "");
          if (vaildPhoneNumberCode.length === phones.length) {
            showPhoneError = false;
            phonesToSave = [...vaildPhoneNumber];
          } else {
            phonesToSave = [];
            alert(TEXT_VALID_COUNTRY_CODE);
            showPhoneError = true;
            return;
          }
        } else {
          phonesToSave = [];
          alert(TEXT_VALID_PHONE_CODE);
          showPhoneError = true;
          return;
        }
      }

      if (showPhoneError) {
        return;
      }

      setIsLoading(true);

      const filteredEmails = emailsToSave.filter((email) => email.id !== userId);

      if (filteredEmails.length !== 0) {
        try {
          for (const em of filteredEmails) {
            if (em.id === 0 || em.verified === true) {
              const emailObj = {
                Id: em.id,
                UserId: Number(userId),
                EmailType: String(em.emailType).charAt(0),
                Email: em.email,
                ModifiedBy: Number(userId),
                isPublicEmail: em.isPublicEmail,
                isPrivateEmail: em.isPrivateEmail
              };
              const res = await Postrequestcall(
                SAVE_USERE_MAILS,
                [emailObj],
                loginData?.accessToken
              );
              // Adjust the exact condition 'res.status === false' based on your API's response structure
              if (res.status === false || res.data?.status === false) {
                throw res;
              }
            }
          }
        } catch (res) {
          // Toast the error message as requested
          toast.error(res?.data?.data?.[0]?.message || "An error occurred");
        }
      }

      if (phonesToSave.length > 0) {
        const changedPhones = phonesToSave.filter((newPh) => {
          if (newPh.id === 0) return true;
          const copy = phoneCopy.find((c) => c.id === newPh.id);
          if (!copy) return true;
          // Compare phoneType and isPublicPhone
          if (
            copy.phoneType !== newPh.phoneType ||
            copy.isPublicPhone !== newPh.isPublicPhone ||
            copy.countryCode !== newPh.countryCode
          ) {
            return true;
          }
          return false;
        });

        if (changedPhones.length > 0) {
          for (const ph of changedPhones) {
            const obj = {
              Id: ph.id,
              UserId: Number(userId),
              PhoneType: String(ph.phoneType).charAt(0),
              PhoneNo: ph.phoneNo.replace(/[^a-zA-Z0-9]/g, ""),
              ModifiedBy: Number(userId),
              CountryCode: ph.countryCode,
              isPublicPhone: ph.isPublicPhone,
              isPrivatePhone: ph.isPrivatePhone
            };
            await Postrequestcall(SAVE_USER_PHONES, [obj], loginData?.accessToken);
          }
        }
      }

      const deleteEmailArray = emailsToDelete
        .filter((p) => p.id != 0)
        .map((p) => ({
          Id: p.id,
          ModifiedBy: userId
        }));

      if (deleteEmailArray.length > 0) {
        await Postrequestcall(DELETE_USER_EMAILS, deleteEmailArray, loginData?.accessToken);
      }

      const deletePhoneArray = phonesToDelete
        .filter((p) => p.id != 0)
        .map((p) => ({
          Id: p.id,
          ModifiedBy: userId
        }));
      if (deletePhoneArray.length > 0) {
        await Postrequestcall(DELETE_USER_PHONES, deletePhoneArray, loginData?.accessToken);
      }

      if (isAddressModified) {
        const saveAddressObj = {
          Id: addressObj.id,
          UserId: userId,
          Address1: addressObj.address1,
          Address2: addressObj.address2,
          Country: addressObj.country,
          Province: addressObj.province,
          City: addressObj.city,
          PostalCode: addressObj.postalCode,
          CreatedBy: userId,
          ModifiedBy: userId,
          DateCreated: moment().format(),
          DateModified: moment().format()
        };
        await Postrequestcall(SAVE_USER_ADDRESS, saveAddressObj, loginData?.accessToken);
      }
      setPhonesToDelete([]);
      setEmailsToDelete([]);
      setIsAddressModified(false);
      getInformationData();
      setIsEmailModified(false);
      setIsPhoneModified(false);
      setIsAddressModified(false);
      setIsLoading(false);
      handleClose();
    } catch (error) {
      setIsLoading(false);
      console.log("handleSaveButtonClick-> Error Updating About Data: ", error);
    }
  }

  // Changes a email type in the state array
  function handleEmailCheckChange(newType, index) {
    let newEmailsData = [...emails];
    newEmailsData[index].isPublicEmail = newType;
    setEmails(newEmailsData);
    setIsEmailModified(true);
  }
  // Changes a email type in the state array
  function handleEmailTypeChange(newType, index) {
    let newEmailsData = [...emails];
    newEmailsData[index].emailType = newType;
    setEmails(newEmailsData);
    setIsEmailModified(true);
  }

  // Changes a email in the state array
  const handleEmailChange = async (e, index) => {
    if (e.target.value !== "") {
      setIsEmailModified(true);
    } else {
      setIsEmailModified(false);
    }

    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    let newEmailsData = [...emails];
    newEmailsData[index].email = inputValue;
    setEmails(newEmailsData);
  };

  // Removes an email item from the emails state array
  async function removeEmail(index) {
    let keepEmails = [...emails];
    let deletedEmail = keepEmails.splice(index, 1)[0]; // Remove email at index

    // Add deletedEmail to array for API delete (on save)
    let newDeleteArray = [...emailsToDelete];
    newDeleteArray.push(deletedEmail);
    await setEmailsToDelete(newDeleteArray);

    setEmails(keepEmails);
  }

  const handleOpenVerifyEmailModal = async (item) => {
    let firstName = loginData?.userInformation?.FirstName;
    let lastName = loginData?.userInformation?.LastName;

    let loginUserName =
      (firstName != null && firstName != "" ? firstName : "") +
      " " +
      (lastName != null && lastName != "" ? lastName : "");

    let userName = loginUserName != "" ? loginUserName : "user";

    try {
      let getEmailResponse = await Getrequestcall(
        SEND_USER_VERIFICATION_EMAIL + "/" + item?.email + "/" + userName,
        loginData?.accessToken
      );
      if (getEmailResponse.status === 200) {
        // An email has been sent to your inbox.
        handleClose();
        setVerifyEmailModalOpen(true);
      }
    } catch (error) {
      console.log(
        "handleOpenVerifyEmailModal-> Error While Sending User Verification Email: ",
        error
      );
    }
  };

  const handleOpenVerifyPhoneModal = async (num) => {
    // sendMessage(num);
    const res = await handledata(num);
    if (res?.status === 200) {
      handleClose();
      setVerifyPhoneModalOpen(true);
    }
  };

  const handleSearch = async (place) => {
    let lat = Number(place.geometry.location.lat());
    let lng = Number(place.geometry.location.lng());

    const addressObject = await getAddress({ lat, lng });
    const newAdd = {
      id: addressObj?.id,
      address1: addressObject?.objAddress?.address,
      address2: addressObject?.objAddress?.address1,
      city: addressObject?.objAddress?.city,
      province: addressObject?.objAddress?.province,
      country:
        lat == "56.130366" && lng == "-106.346771" ? "Canada" : addressObject?.objAddress?.country,
      postalCode: addressObject?.objAddress?.postalCode
    };
    setChangeCountry(false);
    setAddressObj(newAdd);
    setSearchTerm(addressObject?.objAddress?.address);
    setIsAddressModified(true);
  };

  function addEmail() {
    let newEmailArray = [...emails];
    newEmailArray.push({
      id: 0, // New items hardcoded id=0
      userId: userId,
      emailType: "P", // Type: Personal
      email: "",
      modifiedBy: userId,
      verified: true,
      isPublicEmail: false,
      isPrivateEmail: false
    });

    setEmails(newEmailArray);
    setIsEmailModified(true);
  }

  // Changes a phone type in the state array
  function handlePhoneTypeChange(newType, index) {
    let newPhonesData = [...phones];
    newPhonesData[index].phoneType = newType;
    setPhones(newPhonesData);
    setIsPhoneModified(true);
  }

  function handlePhoneCheckChange(newType, index) {
    let newPhonesData = [...phones];
    newPhonesData[index].isPublicPhone = newType;
    setPhones(newPhonesData);
    setIsPhoneModified(true);
  }

  function handleCountryCodeChange(countrycodeType, index) {
    let newPhonesData = [...phones];
    newPhonesData[index].countryCode = countrycodeType;
    setPhones(newPhonesData);
    setIsPhoneModified(true);
  }

  // Changes a phone in the state array
  function handlePhoneChange(newPhone, index) {
    let newPhonesData = [...phones];
    newPhonesData[index].phoneNo = newPhone;
    setPhones(newPhonesData);
  }

  // Removes a phone item in the phones state array
  async function removePhone(index) {
    let keepPhones = [...phones];
    let deletedPhone = keepPhones.splice(index, 1)[0]; // Remove phone at index

    // Add deletedPhone to array for API delete (on save)
    let newDeleteArray = [...phonesToDelete];
    newDeleteArray.push(deletedPhone);

    await setPhonesToDelete(newDeleteArray);

    // Update local display
    setPhones(keepPhones);
  }

  // Adds a new (type: home) phone item to the phones state array, with empty phone string
  function addPhone() {
    let newPhoneArray = [...phones];
    newPhoneArray.push({
      id: 0, // New items hardcoded id=0
      userId: userId,
      phoneType: "H", // Type: Home
      phoneNo: "",
      modifiedBy: userId,
      countryCode: "",
      verified: true,
      isPublicPhone: false,
      isPrivatePhone: false
    });

    setPhones(newPhoneArray);
    setIsPhoneModified(true);
  }

  const formatPhoneNumber = (phoneNumberString) => {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return phoneNumberString;
  };

  // Removes an email item from the emails state array
  async function removeEmail(index) {
    let keepEmails = [...emails];
    let deletedEmail = keepEmails.splice(index, 1)[0]; // Remove email at index

    // Add deletedEmail to array for API delete (on save)
    let newDeleteArray = [...emailsToDelete];
    newDeleteArray.push(deletedEmail);
    await setEmailsToDelete(newDeleteArray);
    setEmails(keepEmails);
  }

  return (
    <>
      <Modal open={showAbout ?? false} onClose={handleClose}>
        <Box className="user-modal-responsive">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography sx={{ ml: 1, fontWeight: "bold" }} variant="h5">
              {TEXT_EDIT_ABOUT}
            </Typography>
            <Stack direction={"row"} sx={{ alignItems: "center" }}>
              <IconButton color="primary" onClick={handleClose}>
                <CloseIcon />
              </IconButton>

              <IconButton
                color="primary"
                onClick={() => handleSaveButtonClick()}
                disabled={
                  isEmailModified || isPhoneModified || isAddressModified == true ? false : true
                }>
                <SaveIcon />
              </IconButton>
            </Stack>
          </Box>

          <Box sx={{ height: "500px", padding: "0px 10px", overflow: "auto" }}>
            {
              // Form body
              isLoading ? (
                <Loader />
              ) : (
                <>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {TEXT_ABOUT_INSTRUCTION}
                  </Typography>
                  <Stack sx={{ gap: 2 }}>
                    <Typography variant="h6" sx={{ mt: 1 }}>
                      {TEXT_EMAILS}
                    </Typography>
                    {emails.map((email, index) => (
                      <React.Fragment key={index.toString()}>
                        {!email?.verified ? (
                          <Stack
                            className="pagelist-content"
                            sx={{ gap: 1, display: "flex", alignItems: "center" }}

                            direction={"column"}
                            style={{ padding: "15px", marginTop: "0px" }}>
                            <Typography>
                              <span style={{ fontWeight: "bold" }}>{email?.email} </span>
                              {TEXT_NEEDS_TO_BE_VERIFIED}
                            </Typography>
                            <Stack sx={{ gap: 1 }} direction={"row"}>
                              {loginData?.userInformation?.Email !== email?.email && (
                                <Button
                                  color="error"
                                  variant="contained"
                                  onClick={() => {
                                    removeEmail(index);
                                    setIsEmailModified(true);
                                  }}>
                                  {BUTTON_DELETE}
                                </Button>
                              )}
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handleOpenVerifyEmailModal(email)}>
                                {BUTTON_VERIFY}
                              </Button>
                            </Stack>
                          </Stack>
                        ) : (
                          <>
                            {loginData?.userInformation?.Email === email?.email &&
                            email?.verified ? (
                              <Stack sx={{ gap: 1 }} direction={"row"}>
                                <Select
                                  variant="outlined"
                                  value="P"
                                  disabled
                                  style={{
                                    width: "110px",
                                    background: "#cccccc"
                                  }}>
                                  <MenuItem value="P">{TEXT_PRIMARY}</MenuItem>
                                </Select>
                                <TextField
                                  id={"email-textfield-primary"}
                                  style={{ background: "#cccccc" }}
                                  variant="outlined"
                                  defaultValue={loginData?.userInformation?.Email}
                                  fullWidth
                                  disabled
                                />
                              </Stack>
                            ) : (
                              <Box>
                                <Stack
                                  spacing={1}
                                  direction="row"
                                  sx={{ alignItems: "flex-start" }}>
                                  <Checkbox
                                    color="primary"
                                    checked={email.isPublicEmail}
                                    onChange={(event) =>
                                      handleEmailCheckChange(event.target.checked, index)
                                    }
                                  />
                                  <FormControl sx={{ minWidth: 120 }}>
                                    <InputLabel id="demo-controlled-open-select-label">
                                      {TEXT_EMAIL_TYPE}
                                    </InputLabel>
                                    <Select
                                      labelId="demo-controlled-open-select-label"
                                      id="demo-controlled-open-select"
                                      label={TEXT_EMAIL_TYPE}
                                      name={"email-select"}
                                      value={email?.emailType.charAt(0)}
                                      onChange={(event) =>
                                        handleEmailTypeChange(event.target.value, index)
                                      }>
                                      <MenuItem value="P">{TEXT_PERSONAL}</MenuItem>
                                      <MenuItem value="W">{TEXT_WORK}</MenuItem>
                                      <MenuItem value="O">{TEXT_OTHER}</MenuItem>
                                    </Select>
                                  </FormControl>

                                  <TextField
                                    key={index}
                                    id={"email-textfield-" + index}
                                    label={TEXT_EMAIL}
                                    placeholder="name@buildid.com"
                                    defaultValue={email.email}
                                    fullWidth
                                    variant="outlined"
                                    name="school"
                                    value={email.email}
                                    onChange={(e) => handleEmailChange(e, index)}
                                  />

                                  <IconButton
                                    id={index.toString()} // Convert index to string
                                    color="secondary"
                                    onClick={() => {
                                      removeEmail(index);
                                      setIsEmailModified(true);
                                    }}>
                                    <RemoveCircle />
                                  </IconButton>
                                </Stack>
                              </Box>
                            )}
                          </>
                        )}
                      </React.Fragment>
                    ))}

                    <Button
                      variant="text"
                      style={{ color: BIBlue, margin: "10px 0px" }}
                      onClick={addEmail}>
                      {BUTTON_ADD_EMAIL}
                    </Button>
                  </Stack>
                  <Divider />

                  <Stack sx={{ gap: 2 }}>
                    <Typography variant="h6" sx={{ mt: 1 }}>
                      {TEXT_PHONE_NUMBERS}
                    </Typography>
                    {phones.map((num, index) => (
                      <React.Fragment key={index.toString()}>
                        {!num.verified ? (
                          <Stack
                            className="pagelist-content"
                            sx={{ gap: 1, display: "flex", alignItems: "center" }}

                            direction={"column"}
                            style={{ padding: "15px", marginTop: "0px" }}>
                            <Typography>
                              <span style={{ fontWeight: "bold" }}>
                                {formatPhoneNumber(num.phoneNo)}{" "}
                              </span>
                              {TEXT_NEEDS_TO_BE_VERIFIED}
                            </Typography>
                            <Stack sx={{ gap: 1 }} direction={"row"}>
                              <Button
                                color="secondary"
                                variant="contained"
                                onClick={() => {
                                  removePhone(index);
                                  setIsPhoneModified(true);
                                }}>
                                {BUTTON_DELETE}
                              </Button>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handleOpenVerifyPhoneModal(num)}>
                                {BUTTON_VERIFY}
                              </Button>
                            </Stack>
                          </Stack>
                        ) : (
                          <Box>
                            <Stack spacing={1} direction="row" sx={{ alignItems: "flex-start" }}>
                              <Checkbox
                                color="primary"
                                checked={num.isPublicPhone}
                                onChange={(event) =>
                                  handlePhoneCheckChange(event.target.checked, index)
                                }
                              />
                              <FormControl sx={{ minWidth: 95 }}>
                                <InputLabel id="demo-controlled-open-select-label">
                                  {TEXT_PHONE_TYPE}
                                </InputLabel>
                                <Select
                                  labelId="demo-controlled-open-select-label"
                                  id="demo-controlled-open-select"
                                  label={TEXT_PHONE_TYPE}
                                  value={num.phoneType.charAt(0)}
                                  onChange={(event) =>
                                    handlePhoneTypeChange(event.target.value, index)
                                  }>
                                  <MenuItem value="H">{TEXT_HOME}</MenuItem>
                                  <MenuItem value="M">{TEXT_MOBILE}</MenuItem>
                                  <MenuItem value="W">{TEXT_WORK}</MenuItem>
                                  <MenuItem value="O">{TEXT_OTHER}</MenuItem>
                                </Select>
                              </FormControl>

                              <FormControl sx={{ minWidth: 80 }}>
                                <InputLabel id="demo-controlled-open-select-label">
                                  {TEXT_CODE}
                                </InputLabel>
                                <Select
                                  labelId="demo-controlled-open-select-label"
                                  id="demo-controlled-open-select"
                                  label={TEXT_COUNTRY_CODE}
                                  value={num.countryCode}
                                  onChange={(event) =>
                                    handleCountryCodeChange(event.target.value, index)
                                  }>
                                  <MenuItem value="+1">+1</MenuItem>
                                  <MenuItem value="+91">+91</MenuItem>
                                  <MenuItem value="+44">+44</MenuItem>
                                </Select>
                              </FormControl>
                              <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor={`formatted-text-mask-input-${index}`}>
                                  {TEXT_PHONE_NUMBER_PLACEHOLDER}
                                </InputLabel>
                                <Input
                                  sx={{}}
                                  value={num.phoneNo} // Set the value from the mapped phone number
                                  onChange={(event) => handlePhoneChange(event.target.value, index)} // Update the specific phone number
                                  name={`textmask-${index}`}
                                  id={`formatted-text-mask-input-${index}`}
                                  inputComponent={TextMaskCustom}
                                />
                              </FormControl>
                              <IconButton
                                id={index.toString()}
                                color="secondary"
                                onClick={() => {
                                  removePhone(index);
                                  setIsPhoneModified(true);
                                }}>
                                <RemoveCircle />
                              </IconButton>
                            </Stack>
                          </Box>
                        )}
                      </React.Fragment>
                    ))}

                    <Button
                      variant="text"
                      style={{ color: BIBlue, margin: "10px 0px" }}
                      onClick={addPhone}>
                      {BUTTON_ADD_PHONE}
                    </Button>
                  </Stack>
                  <Divider />
                  <Stack sx={{ gap: 2 }}>
                    <>
                      <Stack>
                        <Typography variant="h6" sx={{ mt: 1 }}>
                          {TEXT_ADDRESS}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                          {" "}
                          {TEXT_ADD_SUBHEADING}
                        </Typography>
                      </Stack>
                      {addressObj?.country == "" ? (
                        <div className="input-container">
                          <FormControl variant="outlined" fullWidth>
                            <TextField
                              select
                              label={TEXT_SELECT_COUNTRY}
                              onChange={(e) => {
                                handleAddressChange(e);
                              }}
                              fullWidth
                              variant="outlined"
                              name="country"
                              value={addressObj?.country}>
                              {countries.map((c, i) => (
                                <MenuItem key={i} value={c}>
                                  {c}
                                </MenuItem>
                              ))}
                            </TextField>
                          </FormControl>
                        </div>
                      ) : (
                        <>
                          <div className="input-container">
                            <FormControl variant="outlined" fullWidth>
                              <TextField
                                select
                                label={TEXT_SELECT_COUNTRY}
                                onChange={(e) => {
                                  handleAddressChange(e);
                                }}
                                fullWidth
                                variant="outlined"
                                name="country"
                                value={addressObj?.country}>
                                {countries.map((c, i) => (
                                  <MenuItem key={i} value={c}>
                                    {c}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </FormControl>
                          </div>
                          <div className="input-container">
                            <SearchMap
                              setSearchTerm={setSearchTerm}
                              searchTerm={searchTerm}
                              handleSearch={handleSearch}
                              setSearchTextFlag={setSearchTextFlag}
                              searchTextFlag={searchTextFlag}
                              address={addressObj?.address1}
                              changeCountry={changeCountry}
                              placeholder={TEXT_ADDRESS}
                            />
                          </div>

                          <div className="input-container">
                            <TextField
                              fullWidth
                              label={TEXT_ADD_PLACEHOLDER}
                              variant="outlined"
                              name="address2"
                              value={addressObj?.address2 || ""}
                              onChange={handleAddressChange}
                            />
                          </div>
                          <div className="input-container">
                            <TextField
                              fullWidth
                              label={TEXT_CITY_PLACEHOLDER}
                              variant="outlined"
                              name="city"
                              value={addressObj?.city}
                              onChange={handleAddressChange}
                            />
                          </div>
                          {addressObj?.country !== "United Kingdom" ? (
                            <div className="input-container">
                              <FormControl variant="outlined" fullWidth>
                                <TextField
                                  select
                                  label={TEXT_PROVIENCE}
                                  fullWidth
                                  variant="outlined"
                                  name="province"
                                  value={addressObj?.province}
                                  onChange={handleAddressChange}>
                                  {provinceList.map((p, i) => (
                                    <MenuItem key={i} value={p.province}>
                                      {p.province}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </FormControl>
                            </div>
                          ) : (
                            <> </>
                          )}

                          <div className="input-container">
                            <TextField
                              fullWidth
                              label={TEXT_POSTAL_CODE}
                              variant="outlined"
                              name="postalCode"
                              value={addressObj?.postalCode}
                              onChange={handleAddressChange}
                            />
                          </div>
                          <div className="input-container">
                            <Button color="primary" fullWidth onClick={clearAddress}>
                              {TEXT_CLEAR_ADDRESS}
                            </Button>
                          </div>
                        </>
                      )}
                    </>
                  </Stack>
                </>
              )
            }
          </Box>
        </Box>
      </Modal>
    </>
  );
}
